const colors = {
  additional: {
    blueColor: {
      DODGER_BLUE: '#1DADF5',
      DODGER_BLUE_2: '#23AEF5',
      MISCHKA: '#CFD3DE',
      ORACLE: '#3E6B7D',
    },
    greyColor: {
      ALTO: '#E0E0E0',
      MERCURY: '#E8E8E8',
      SILVER_CHALICE: '#A6A6A6',
      TUNDORA: '#474747',
    },
    orangeColor: {
      BLAZE_ORANGE: '#F46200',
    },
    redColor: {
      WILD_WATERMELON: '#FF5A6E',
      RED_ORANGE: '#FF3F25',
    },
  },
  main: {
    accentColor: {
      SECONDARY: '#F8B91C',
      PRIMARY: '#29D5AC',
    },
    backgroundColor: {
      SECONDARY: '#F6F6F6',
      PRIMARY: '#FFFFFF',
    },
    textColor: {
      ALTERNATIVE1: '#81C5E1',
      ALTERNATIVE2: '#5E626E',
      SECONDARY: '#FFFFFF',
      PRIMARY: '#000000',
      ORANGE: '#F8B91C',
    },
  },
  icon: {
    light: '#ffffff',
    dark: '#13171e',
  },
};

export default colors;
